import { styled } from 'styled-components';

const sectionLabel = `
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`;

export const HeaderTitle = styled.div`
  font-size: 22px;
  font-weight: 700;
  line-height: 30px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.main};
`;

export const HeaderRoute = styled.div`
  margin-top: 4px;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.defaultLink};
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const CloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 6px;
  background: transparent;
  font-size: 18px;
  cursor: pointer;
  color: ${({ theme }) => theme.defaultLink};

  &:hover {
    background: ${({ theme }) => theme.primaryBg10};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.primaryBg};
  }
`;

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
`;

export const SummaryLabel = styled.div`
  ${sectionLabel}
  color: ${({ theme }) => theme.lightText};
`;

export const SummaryValue = styled.div`
  margin-top: 4px;
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme }) => theme.main};
  overflow-wrap: anywhere;
`;

export const Actions = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 20px;

  .ant-btn {
    min-width: 156px;
    font-size: 14px;
    border-radius: 6px;
  }
`;

export const TabsContainer = styled.div`
  .ant-tabs-nav::before {
    border-bottom: none;
  }

  .ant-tabs-tab {
    font-size: 15px;
    font-weight: 600;
  }

  .ant-tabs-tab .ant-tabs-tab-btn {
    color: ${({ theme }) => theme.lightText};
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${({ theme }) => theme.main};
  }

  .ant-tabs-ink-bar {
    height: 3px;
    background: ${({ theme }) => theme.accent};
  }

  .ant-table-thead > tr > th {
    background: ${({ theme }) => theme.defaultGrayBgColor};
    color: ${({ theme }) => theme.lightText};
    ${sectionLabel}

    &::before {
      display: none;
    }
  }
`;

export const TabCount = styled.span`
  margin-left: 8px;
  font-weight: 500;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;

  .ant-input-affix-wrapper {
    width: 260px;
    height: 36px;
    font-size: 14px;
    border-radius: 6px;
    background: ${({ theme }) => theme.defaultGrayBgColor};

    .ant-input {
      background: transparent;
    }

    .ant-input-prefix {
      margin-inline-end: 8px;
      color: ${({ theme }) => theme.lightText};
    }
  }
`;

export const SectionLabel = styled.div`
  ${sectionLabel}
  color: ${({ theme }) => theme.lightText};
`;

export const VehicleList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const VehicleRow = styled.li`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.2fr) auto 24px;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 6px;
  cursor: pointer;

  &:nth-child(odd) {
    background: ${({ theme }) => theme.defaultGrayBgColor};
  }

  &:hover {
    background: ${({ theme }) => theme.primaryBg10};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.primaryBg};
    outline-offset: -2px;
  }
`;

export const VehicleVin = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: ${({ theme }) => theme.main};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const VehicleStatus = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.textColor};
  white-space: nowrap;
`;

export const VehicleStatusLabel = styled.span`
  margin-right: 4px;
  color: ${({ theme }) => theme.lightText};
`;

export const VehicleModel = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.defaultLink};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RowChevron = styled.span`
  color: ${({ theme }) => theme.lightText};
  text-align: right;
`;
